import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, Share2 } from "lucide-react";
import { api } from "../../lib/api";

export default function ReferralLeaderboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/community/referral-leaderboard").then((r) => setD(r.data)).catch(() => setD({ rows: [] })); }, []);
  if (!d) return null;
  return (
    <section className="rounded-2xl border border-slate-800 bg-[#131722] p-4" data-testid="rail-referrals">
      <div className="flex justify-between items-center mb-2"><h3 className="font-semibold text-sm inline-flex items-center gap-1.5"><Trophy className="w-4 h-4 text-amber-300" />Top sharers</h3><span className="text-[10px] font-mono text-slate-500">{d.month}</span></div>
      {d.rows.length ? (
        <ol className="space-y-1.5" data-testid="referral-rows">{d.rows.map((r) => (
          <li key={r.rank} className="flex items-center gap-2 text-sm" data-testid={`referral-row-${r.rank}`}>
            <span className={`w-5 text-center font-mono text-xs ${r.rank <= 3 ? "text-amber-300" : "text-slate-500"}`}>{r.rank}</span>
            {r.picture ? <img src={r.picture} alt="" className="w-6 h-6 rounded-full object-cover" /> : <span className="w-6 h-6 rounded-full bg-slate-800 grid place-items-center text-[10px] font-bold">{r.name[0]}</span>}
            <Link to={r.profile} className="flex-1 truncate hover:text-cyan-300">{r.name}{r.connector && <span className="ml-1 text-[9px] font-mono text-lime-300">CONNECTOR</span>}</Link>
            <span className="text-xs text-slate-400">{r.signups} signup{r.signups === 1 ? "" : "s"}</span>
          </li>))}</ol>
      ) : <p className="text-xs text-slate-500" data-testid="referral-empty">No referrals yet this month — be the first.</p>}
      <p className="mt-3 text-[11px] text-slate-500 inline-flex items-center gap-1"><Share2 className="w-3 h-3" />Share any page with the share button · ${d.credit_per_signup} book credit per friend who joins</p>
    </section>
  );
}
